import request from '../../../api/request';
import { TutorAssignmentFilters, TutorAssignmentForm } from './types';

const ENDPOINTS = {
  FORM_DATA: `maintainers-portal/tutor-management/tutor-assignment/form`,
  DOWNLOAD_BASE: `maintainers-portal/tutor-management/tutor-assignment/base`,
  DOWNLOAD_TEMPLATE: `maintainers-portal/tutor-management/tutor-assignment/template`,
  UPLOAD_DATA: `maintainers-portal/tutor-management/tutor-assignment/data`,
};

export const form = () => {
  return request<TutorAssignmentForm>(ENDPOINTS.FORM_DATA);
};

export const downloadBaseInformation = (params: TutorAssignmentFilters) => {
  return request<any>(ENDPOINTS.DOWNLOAD_BASE, {
    responseType: 'blob',
    params,
  });
};

export const downloadTemplate = (params: TutorAssignmentFilters) => {
  return request<any>(ENDPOINTS.DOWNLOAD_TEMPLATE, {
    responseType: 'blob',
    params,
  });
};

export const uploadData = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return request<any>(ENDPOINTS.UPLOAD_DATA, {
    responseType: 'blob',
    method: 'POST',
    data: formData,
  });
};
